// ============================================================
// Freemium / Pro configuration for CreditCost (web).
// Fulfillment (Stripe webhook + email) lives entirely on NotaSuite.
// This app only opens the payment link and validates the code.
// ============================================================

// Free tier limit — how many projects a non-Pro user can create.
export const FREE_PROJECT_LIMIT = 1;

// In-app free trial length (days). New users get full Pro this long.
export const TRIAL_DAYS = 7;

// Existing Stripe Payment Link for the one-time $69 Lifetime Pro.
export const STRIPE_PAYMENT_LINK = "https://buy.stripe.com/fZuaEX6jB4NG2hr3U6dUY00";
export const UPGRADE_URL = STRIPE_PAYMENT_LINK;

// Single one-time price (display only).
export const PRO_PRICE = "$69";

// YOUR Emergent partner / referral link (shown to free users).
export const REFERRAL = {
  code: "leil771640",
  url: "https://app.emergent.sh/register?ref=leil771640",
  note: "New to Emergent? Sign up with my link — we both get free credits.",
};

// Lead-gen footer (free users only).
export const TINGTOWN_URL = "https://tingtown.com/developer-district";

export const PRO_FEATURES = [
  {
    icon: "Infinity",
    title: "Unlimited projects",
    sub: "Estimate every client & build, not just one.",
  },
  {
    icon: "FileText",
    title: "PDF & CSV export",
    sub: "Send polished quotes and spreadsheets to clients.",
  },
  {
    icon: "Sparkles",
    title: "Remove the promo footer",
    sub: "Drop the “get your own” call-to-action for a clean look.",
  },
];
